import auth from "@/middleware/auth";

export default [
    {
        path: "propostasConsorcio",
        name: "propostasConsorcio",
        meta: { middleware: [auth] },
        component: () => import("./PropostasConsorcio")
    }
];
